export const textWrap = (target) => {
  const targetText = target;
  const textArr = targetText.split('<br>');
  let textWrapText = "";
  for(let i = 0; i < textArr.length; i++ ){
    let text = 	textArr[i].split('').reduce((acc, v) => {
      if(!v.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~\s]$/)){
        return acc + `<span lang="ja">${v}</span>`;
      }else{
        return acc + `<span>${v}</span>`;
      }
    }, "");
    if(i === textArr.length - 1){
      textWrapText += text;
    }else{
      textWrapText += text + '<br>';
    }
  }
  return textWrapText;
}
